import type { ComponentProps, PropsWithChildren, ReactElement } from 'react';
import { Suspense } from 'react';

import { PendingPage } from '@bestseller-bit/frontend-community.components.pending-page';

/**
 * This component standardizes the usage of Suspense with a PendingPage fallback.
 * It can be used to wrap lazily loaded microfrontends or components that take up big areas in the UI.
 */
export const SuspenseWithPending = ({
    children,
    ...pendingPageProps
}: PropsWithChildren<ComponentProps<typeof PendingPage>>): ReactElement => (
    <Suspense
        fallback={
            <div
                style={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <PendingPage
                    title="Buying Portal"
                    {...pendingPageProps}
                />
            </div>
        }
    >
        {children}
    </Suspense>
);
